/**
 * コラム記事シェアボタン：リンクコピー機能
 *
 * .js-column-share-copy をクリックすると現在の URL をクリップボードにコピーし、
 * aria-label でフィードバックを表示する（2 秒後に元に戻す）。
 */
const columnShare = () => {
  const copyBtn = document.querySelector('.js-column-share-copy');
  if (!copyBtn) return;

  copyBtn.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      copyBtn.setAttribute('aria-label', 'コピーしました');
      setTimeout(() => {
        copyBtn.setAttribute('aria-label', 'リンクをコピー');
      }, 2000);
    } catch (err) {
      console.error('クリップボードへのコピーに失敗しました', err);
    }
  });
};

export { columnShare };
